var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.55469,
    y: 0.6875,
    width: 28.625,
    height: 29.625,
    rx: 14.3125,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.55469,
    y: 0.6875,
    width: 28.625,
    height: 29.625,
    rx: 14.3125,
    stroke: "#77553D",
    strokeWidth: 1.375
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1152 20.0005L13.6152 15.5005L18.1152 11.0005",
    stroke: "#77553D",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackCircle);
export default __webpack_public_path__ + "static/media/back-circle.a03ee26b7d6e022ec77a72209cf4bcee.svg";
export { ForwardRef as ReactComponent };